var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "listMainContainer", staticClass: "list__app list" },
    [
      _c(
        "div",
        {
          staticClass: "list__items",
          class: _vm.activeItem !== null ? "list__items_active" : "",
        },
        _vm._l(_vm.items, function (item, itemKey) {
          return _c(
            "div",
            {
              ref: "listItem" + item.id,
              refInFor: true,
              staticClass: "list__item",
              class: item.isActive ? "list__item_active" : "",
            },
            [
              _c(
                "div",
                {
                  staticClass: "list__item-wrapper",
                  on: {
                    click: function ($event) {
                      return _vm.activateItem(item)
                    },
                  },
                },
                [
                  _c("div", {
                    staticClass: "list__item-title",
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          _vm.listTranslationsKey + "[" + itemKey + "].title"
                        )
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "list__item-arrow",
                    class: item.isActive ? "list__item-arrow_active" : "",
                    domProps: {
                      innerHTML: _vm._s(require("../img/listArrow.svg")),
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "collapse-transition",
                { attrs: { duration: 500, easing: "ease-in-out" } },
                [
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: item.isActive,
                        expression: "item.isActive",
                      },
                    ],
                    staticClass: "list__item-content",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t(
                          _vm.listTranslationsKey + "[" + itemKey + "].text"
                        )
                      ),
                    },
                  }),
                ]
              ),
            ],
            1
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }